import React from "react";
import { get } from "lodash";
import { Box, Button, Typography } from "@mui/material";
import Modal from "../../../components/Modal";
import { useTranslation } from "react-i18next";

const IntegrationField = ({ label, value }) => {
  return (
    <Box fullWidth mb={2}>
      <Typography variant="subtitle" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body1" color="textPrimary">
        {value}
      </Typography>
    </Box>
  );
};

const TokenModal = ({ integration, open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      showCloseIcon
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t("manageRepository.integrationToken.title")}
        </Typography>
      }
      open={open}
      onClose={() => onClose()}
      dialogContent={
        <Box display="flex" flexDirection="column">
          <IntegrationField
            label={t("manageRepository.integrationToken.nameLabel")}
            value={get(integration, "name")}
          />
          <IntegrationField
            label={t("manageRepository.integrationToken.redirectUriLabel")}
            value={get(integration, "redirectUri")}
          />
          <IntegrationField
            label={t("manageRepository.integrationToken.clientIdLabel")}
            value={get(integration, "uid")}
          />
          <IntegrationField
            label={t("manageRepository.integrationToken.clientSecretLabel")}
            value={get(integration, "secret")}
          />
        </Box>
      }
      dialogActions={
        <>
          <Button color="primary" onClick={() => onClose()}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" onClick={() => onClose()}>
            Ok
          </Button>
        </>
      }
      maxWidth="sm"
      fullWidth
      scrollable
    />
  );
};

export default TokenModal;
